import React, { JSX } from 'react';
import {
  Field,
  Image,
  ImageField,
  Link,
  LinkField,
  RichText,
} from '@sitecore-jss/sitecore-jss-nextjs';

type ContentCarouselCardProps = {
  link: LinkField;
  linkType: string;
  description: Field<string>;
  heading: Field<string>;
  image: ImageField;
  index: number;
  uid?: string;
};

const ContentCarouselCard = ({
  link,
  linkType,
  description,
  heading,
  image,
  index,
  uid,
}: ContentCarouselCardProps): JSX.Element => {
  return (
    <div
      className="content-carousel-card groupings-anim animated"
      id={`content-carousel-card-${uid}-${index}`}
      style={{ '--index': index + 1 } as React.CSSProperties}
    >
      <div className="content-carousel-img">
        {image && <Image field={image} alt="OSF Healthcare" />}
      </div>
      <div className="content-carousel-content">
        {heading?.value && (
          <h3 className="content-carousel-card-heading osf-display-h3">
            {heading?.value}
          </h3>
        )}
        {description?.value && (
          <RichText
            className="content-carousel-card-description osf-body-copy"
            field={description}
            tag=""
          />
        )}
        {link?.value?.href && (
          <Link
            className={linkType ? `btn-${linkType.toLowerCase()}` : ''}
            aria-label="Link Learn More"
            data-target=""
            rel="noreferrer"
            field={link}
          />
        )}
      </div>
    </div>
  );
};

export default ContentCarouselCard;
